// removed by extract-text-webpack-plugin
module.exports = {"Container":"Soglashenie__Container___2VMAl"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Soglashenie/Soglashenie.scss
// module id = 1413
// module chunks = 0